/**
 * Resolve a human-readable booking code from API/booking-shaped objects or message metadata.
 */
export const resolveBookingCode = (source = {}) => {
  if (!source || typeof source !== 'object') return null;

  const direct =
    source.bookingCode ||
    source._bookingCode ||
    source.attributes?.metadata?.bookingCode ||
    source.metadata?.bookingCode;

  if (direct && String(direct).trim()) {
    return String(direct).trim();
  }

  return null;
};

export const shouldShowBookingCodeOnMessage = (metadata = {}) => {
  const kind = metadata?.kind;
  if (!kind || !String(kind).startsWith('booking_')) return false;
  return kind !== 'booking_request' && kind !== 'booking_cancellation' && kind !== 'booking_broadcast';
};

export const formatBookingCodeLabel = (bookingCode, { prefix = 'Booking #' } = {}) => {
  const code = resolveBookingCode({ bookingCode });
  if (!code) return null;
  return `${prefix}${code}`;
};
